// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearLanguageCircle = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '17',
      viewBox: '0 0 16 17',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.3252 6.47363H4.67188',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.99609 5.35352V6.47351',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.66406 6.45996C9.66406 9.32663 7.42406 11.6466 4.66406 11.6466',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.3302 11.6466C10.1302 11.6466 9.06354 11.0067 8.29688 10',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.9987 15.1663C11.6806 15.1663 14.6654 12.1816 14.6654 8.49967C14.6654 4.81778 11.6806 1.83301 7.9987 1.83301C4.3168 1.83301 1.33203 4.81778 1.33203 8.49967C1.33203 12.1816 4.3168 15.1663 7.9987 15.1663Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearLanguageCircle };
